<div class="ft-grid-filter-container">
    <select [ngModel]="selectedOption" (ngModelChange)="onSelect($event)">
        <option [ngValue]="null">All</option>
        <option *ngFor="let option of options" [value]="option">
            {{option}}
        </option>
    </select>
</div>
